module.exports = __webpack_public_path__ + "static/media/mononoke-back.b5283dc1.png";